<template>
  <b-modal id="agregar-modal" :title="$t('vGrupos.agregarGrupo')" centered hide-footer ref="modalAgregarGrupo"
    @hidden="resetModal" size="lg">
    <form ref="form" @submit.stop.prevent="registrarGrupo" style="margin-top: -15px">
      <p class="text-danger" v-if="existeNombre">
        {{ $t("vGrupos.msgErrorNombreGrupo") }}
      </p>
      <label for="input-nombre-feedback">{{ $t("Gral.nombre") }}:</label>
      <b-form-input id="input-nombre" v-model="area.nombre" :state="validacionCampoNombre"
        aria-describedby="input-nombre-help input-nombre-feedback" trim @keyup="cambiarStateValidarCampo">
      </b-form-input>
      <b-form-invalid-feedback id="input-nombre-feedback">
        {{ $t("vGrupos.msgErrorGrupo") }}
      </b-form-invalid-feedback>
      <div class="row" :class="[
        validacionCampoNombre
          ? 'validacionCampoNombreMargin'
          : 'validacionCampoNombreSinMargin']">
        <b-col cols="12" sm="6">
          <b-btn class="w-100" @click="$bvModal.hide('agregar-modal')" style="color: white">
            {{ $t("Gral.cancelar") }}
          </b-btn>
        </b-col>
        <b-col cols="12" sm="6" class="margin-top-div-boton-guardar">
          <b-btn variant="info" class="w-100" style="color: white" :disabled="!validacionCampoNombre" type="submit">
            {{ $t("vGrupos.guardarGrupo") }}
          </b-btn>
        </b-col>
      </div>
    </form>
  </b-modal>
</template>


<script>
import AreaDataService from "../../../services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";

export default {
  data() {
    return {
      area: {
        id: 0,
        nombre: "",
        habilitado: false,
      },
      existeNombre: false,
      campoValido: true,
      nameState: null,
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: sessionStorage.getItem('key')
    };
  },
  computed: {
    validacionCampoNombre() {
      return this.campoValido && this.area.nombre.trim() !== '';
    },
  },
  methods: {
    showModal() {
      this.$refs.modalAgregarGrupo.show();
    },

    resetModal() {
      this.area.nombre = "";
      this.nameState = null;
      this.campoValido = true
      this.existeNombre = false
    },

    cambiarStateValidarCampo() {
      if (!this.campoValido) {
        this.campoValido = true
      }
    },

    async registrarGrupo() {
      try {

        const isAdmin = sessionStorage.getItem("idRol");
        let adminIds = [];
        if (isAdmin === process.env.VUE_APP_ID_ADMINISTRADOR) {
          adminIds = [this.usuarioLogueado.id];
        }
        const data = {
          nombre: this.area.nombre,
          habilitado: true,
          adminIds: adminIds,
        };

        const exiseNombreRegistrado = await this.existeNombreGrupo(data.nombre, this.key)

        if (exiseNombreRegistrado) {
          this.existeNombre = true
          this.validarCampo()
          return
        }

        const response = await AreaDataService.create(data, this.key)

        if (response.status === 201) {
          this.$emit("actualizarTabla", response.status);
          this.accion = "Registró el grupo " + data.nombre;
          this.registrarAccion();
          this.alertSweet('success', this.$t("vGrupos.msgRegistro"))
          this.cerrarModal()
        }
      } catch (error) {
        console.error("Error al registrar el grupo:", error);
        this.alertSweet('error', this.$t("vGrupos.msgRegistroError"))
      }
    },

    cerrarModal() {
      this.campoValido = true
      this.$refs.modalAgregarGrupo.hide()
    },

    async existeNombreGrupo(nombre) {
      try {
        const response = await AreaDataService.getExisteAreaByNombre(nombre, this.key)
        return response.data
      } catch (error) {
        console.error("Error al existeNombreGrupo:", error);
        this.alertSweet('error', this.$t("Gral.msgErrorActualizar"))
      }
    },

    validarCampo() {
      this.campoValido = false
    },

    async registrarAccion() {
      let data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };

      try {
        await AccionesDataService.create(data, this.key)
      } catch (error) {
         console.error("Error al registrarAccion:", error);
        this.alertSweet('error', this.$t("Gral.msgErrorDesconocido"))
      }
    },

    alertSweet(icon, message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message
      });
    },
  }
};
</script>

<style>
.validacionCampoNombreMargin {
  margin-top: 8px;
}

.validacionCampoNombreSinMargin {
  margin-top: 0px;
}

@media (min-width: 2500px) {
  .modal-ultrawide-custom {
    max-width: 1000px !important;
  }
  .px-ultrawide {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .custom-input-height {
    height: 60px;
    font-size: 1.2rem;
  }
}
</style>